import SelectRef from 'react-select'

import styled from 'styled-components'
import { ButtonIconCircle as ButtonIconCircleRef } from '../../components/elements/ButtonWithLoader'

export const Select = styled(SelectRef)`
  border: none;

  input  {
    border: none;
  }

  div {
    border: none;
  }

  .css-1u9des2-indicatorSeparator {
    display: none;
  }

  .css-t3ipsp-control {
    box-shadow: 0 0 0 0px ${({ theme }) => theme.colors.primary};
    border: none;
    min-height: 19px;
  }

  .css-t3ipsp-control:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  .css-tj5bde-Svg {
    width: 19px;
    height: 19px;
  }

  .css-1xc3v61-indicatorContainer {
    padding: 0px;
    display: none;
  }

  .css-15lsz6c-indicatorContainer,
  .css-tj5bde-Svg {
    display: none;
  }

  .css-qbdosj-Input {
    padding: 0px;
    margin: 0px;
  }

  .css-1fdsijx-ValueContainer {
    padding: 0px;
  }

  .css-13cymwt-control {
    min-height: 19px;
  }

  .css-166bipr-Input {
    padding: 0px;
    margin: 0px;
  }

  .css-d7l1ni-option {
    background-color: ${({ theme }) => theme.colors.primary}44;
  }

  .css-d7l1ni-option:active {
    background-color: ${({ theme }) => theme.colors.primary}44;
  }

  .css-tr4s17-option {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  .css-tr4s17-option:active {
    background-color: ${({ theme }) => theme.colors.primary};
  }
`

export const Card = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 3rem;
  min-height: 6rem;

  // TO CLEAN UP
  margin: auto;
  margin-bottom: 7rem;
  width: 800px;
  max-width: 100%;
  transform: translateY(2rem);
  position: relative;
  z-index: 2;

  @media screen and (max-width: 768px) {
    width: 100%;
    box-shadow: none;
    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
    padding: 0.5rem;
    margin: 1rem auto;
    margin-bottom: 4rem;
    ${({ searchBarContracted }) => (searchBarContracted ? 'display:none' : '')};
  }
`

export const ExpandButton = styled.i`
  display: none;
  @media screen and (max-width: 768px) {
    display: flex;
    font-size: 3rem;
    color: ${({ theme }) => theme.colors.primary};
    margin: auto;
    justify-content: center;
    transform: rotate(180deg);
    /* margin-bottom: 2rem; */
    /* width: 10rem;

    height: 10rem; */
    ${({ searchBarContracted }) => (!searchBarContracted ? 'display:none' : '')};
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 4fr 1fr 1.2fr;
  align-items: center;
  width: 100%;
  margin: 0 0.6rem;

  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr;
  }
`

export const LocationSelect = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.8rem;
  margin-left: 1rem;
  color: ${({ theme }) => theme.colors.primary};

  @media screen and (max-width: 768px) {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.18);
    border-radius: 1.2rem;
    padding: 0.8rem 1.2rem;
    margin-left: 0rem;
    text-align: center;
  }
`

export const Label = styled.label`
  font-size: 1.1rem;
  font-weight: bold;
`

export const Entry = styled.span`
  /* font-size: 1.5rem; */
`

export const DatesSelect = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;

  span {
    font-size: 1rem;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.primary};
    margin: auto;
  }
  @media screen and (max-width: 768px) {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.18);
    border-radius: 1.2rem;
    padding: 1.2rem;
    margin: 1rem auto;
    display: flex;
    justify-content: center;
    width: 100%;

    svg {
      width: 2rem;
      margin-right: 2rem;
    }
  }
`

export const IconStyle = styled.svg``
export const Icon = () => {
  return (
    <IconStyle xmlns='http://www.w3.org/2000/svg' width='100%' height='23' viewBox='0 0 15 15' fill='none'>
      <g clip-path='url(#clip0_262_296)'>
        <path
          d='M9.96216 0.577393C9.96216 0.258789 10.2771 0 10.6665 0C11.0559 0 11.3708 0.258789 11.3708 0.577393V3.10669C11.3708 3.42529 11.0559 3.68408 10.6665 3.68408C10.2771 3.68408 9.96216 3.42529 9.96216 3.10669V0.577393ZM8.07007 12.6721C8.02856 12.6721 7.9956 12.4976 7.9956 12.2815C7.9956 12.0654 8.02856 11.8909 8.07007 11.8909H9.99756C10.0391 11.8909 10.072 12.0654 10.072 12.2815C10.072 12.4976 10.0391 12.6721 9.99756 12.6721H8.07007ZM1.93481 8.1897C1.89331 8.1897 1.86035 8.01514 1.86035 7.79907C1.86035 7.58301 1.89331 7.40845 1.93481 7.40845H3.8623C3.90381 7.40845 3.93677 7.58301 3.93677 7.79907C3.93677 8.01514 3.90381 8.1897 3.8623 8.1897H1.93481ZM5.00244 8.1897C4.96094 8.1897 4.92798 8.01514 4.92798 7.79907C4.92798 7.58301 4.96094 7.40845 5.00244 7.40845H6.92993C6.97144 7.40845 7.00439 7.58301 7.00439 7.79907C7.00439 8.01514 6.97144 8.1897 6.92993 8.1897H5.00244ZM8.07007 8.1897C8.02856 8.1897 7.9956 8.01514 7.9956 7.79907C7.9956 7.58301 8.02856 7.40845 8.07007 7.40845H9.99756C10.0391 7.40845 10.072 7.58301 10.072 7.79907C10.072 8.01514 10.0391 8.1897 9.99756 8.1897H8.07007ZM11.1389 8.1897C11.0974 8.1897 11.0645 8.01514 11.0645 7.79907C11.0645 7.58301 11.0974 7.40845 11.1389 7.40845H13.0664C13.1079 7.40845 13.1409 7.58301 13.1409 7.79907C13.1409 8.01514 13.1079 8.1897 13.0664 8.1897H11.1389ZM1.93481 10.4309C1.89331 10.4309 1.86035 10.2563 1.86035 10.0403C1.86035 9.82422 1.89331 9.64966 1.93481 9.64966H3.8623C3.90381 9.64966 3.93677 9.82422 3.93677 10.0403C3.93677 10.2563 3.90381 10.4309 3.8623 10.4309H1.93481ZM5.00244 10.4309C4.96094 10.4309 4.92798 10.2563 4.92798 10.0403C4.92798 9.82422 4.96094 9.64966 5.00244 9.64966H6.92993C6.97144 9.64966 7.00439 9.82422 7.00439 10.0403C7.00439 10.2563 6.97144 10.4309 6.92993 10.4309H5.00244ZM8.07007 10.4309C8.02856 10.4309 7.9956 10.2563 7.9956 10.0403C7.9956 9.82422 8.02856 9.64966 8.07007 9.64966H9.99756C10.0391 9.64966 10.072 9.82422 10.072 10.0403C10.072 10.2563 10.0391 10.4309 9.99756 10.4309H8.07007ZM11.1389 10.4309C11.0974 10.4309 11.0645 10.2563 11.0645 10.0403C11.0645 9.82422 11.0974 9.64966 11.1389 9.64966H13.0664C13.1079 9.64966 13.1409 9.82422 13.1409 10.0403C13.1409 10.2563 13.1079 10.4309 13.0664 10.4309H11.1389ZM1.93481 12.6721C1.89331 12.6721 1.86035 12.4976 1.86035 12.2815C1.86035 12.0654 1.89331 11.8909 1.93481 11.8909H3.8623C3.90381 11.8909 3.93677 12.0654 3.93677 12.2815C3.93677 12.4976 3.90381 12.6721 3.8623 12.6721H1.93481ZM5.00244 12.6721C4.96094 12.6721 4.92798 12.4976 4.92798 12.2815C4.92798 12.0654 4.96094 11.8909 5.00244 11.8909H6.92993C6.97144 11.8909 7.00439 12.0654 7.00439 12.2815C7.00439 12.4976 6.97144 12.6721 6.92993 12.6721H5.00244ZM3.6145 0.577393C3.6145 0.258789 3.92944 0 4.31885 0C4.70825 0 5.02319 0.258789 5.02319 0.577393V3.10669C5.02319 3.42529 4.70825 3.68408 4.31885 3.68408C3.92944 3.68408 3.6145 3.42529 3.6145 3.10669V0.577393ZM0.78125 5.53223H14.2175V2.62085C14.2175 2.52319 14.1772 2.43408 14.1125 2.36816C14.0479 2.30347 13.9587 2.26318 13.8599 2.26318H12.5732C12.3572 2.26318 12.1826 2.08862 12.1826 1.87256C12.1826 1.65649 12.3572 1.48193 12.5732 1.48193H13.8611C14.1748 1.48193 14.4592 1.61011 14.6655 1.81641C14.8718 2.02271 15 2.30713 15 2.62085V5.92407V13.8623C15 14.176 14.8718 14.4604 14.6655 14.6667C14.4592 14.873 14.1748 15.0012 13.8611 15.0012H1.13892C0.825195 15.0012 0.540771 14.873 0.334473 14.6667C0.128174 14.4592 0 14.1748 0 13.8611V5.92285V2.62085C0 2.30713 0.128174 2.02271 0.334473 1.81641C0.540771 1.61011 0.825195 1.48193 1.13892 1.48193H2.51465C2.73071 1.48193 2.90527 1.65649 2.90527 1.87256C2.90527 2.08862 2.73071 2.26318 2.51465 2.26318H1.13892C1.04126 2.26318 0.952148 2.30347 0.88623 2.36816C0.821533 2.43286 0.78125 2.52197 0.78125 2.62085V5.53223ZM14.2188 6.3147H0.78125V13.8611C0.78125 13.9587 0.821533 14.0479 0.88623 14.1138C0.950928 14.1785 1.04004 14.2188 1.13892 14.2188H13.8611C13.9587 14.2188 14.0479 14.1785 14.1138 14.1138C14.1785 14.0491 14.2188 13.96 14.2188 13.8611V6.3147ZM6.15601 2.26318C5.93994 2.26318 5.76538 2.08862 5.76538 1.87256C5.76538 1.65649 5.93994 1.48193 6.15601 1.48193H8.7793C8.99536 1.48193 9.16992 1.65649 9.16992 1.87256C9.16992 2.08862 8.99536 2.26318 8.7793 2.26318H6.15601Z'
          fill='#63A1A0'
        />
      </g>
      <defs>
        <clipPath id='clip0_262_296'>
          <rect width='15' height='15' fill='white' />
        </clipPath>
      </defs>
    </IconStyle>
  )
}

export const VerticalBar = styled.hr`
  background: ${({ theme }) => theme.colors.primary};
  border: none;
  width: 2px;
  height: 2.4rem;

  @media screen and (max-width: 768px) {
    display: none;
  }
`

export const ButtonIconCircle = styled(ButtonIconCircleRef)`
  /* margin: 0 0.5rem; */

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 3.5rem;
    border-radius: 1rem;
    margin: 0;
  }
`
